import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { MembershipDisplayModel } from './models/MembershipDisplay.model';

export class MembershipDisplayDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return MembershipDisplayModel.fromDto(dto) as any;
  }
}
